export default "__VITE_ASSET__BaZHaS0O__"